<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">All Countries</h1>
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" :to="{ name: 'create-country' }">create</router-link>
          </div>
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">
            <div v-if="conditionMedicals.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(country, index) in filteredCountries" :key="index">
                  <th scope="row">{{ country.id }}</th>
                  <td>{{ country.name_ar }}</td>
                  <td>{{ country.name_en }}</td>
                  <td>
                    <button class="me-2 btn btn-danger" @click="deleteCountry(country.id)">
                      Delete
                    </button>
                    <router-link class="btn btn-primary spacing"
                      :to="{ name: 'edit-country', params: { id: country.id } }">
                      Edit
                    </router-link>
                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No Countries found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>

import axios from "../../Axios";
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component
export default {
  name: "AllCountries",

  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [], // Store DataTable instance
      countries: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Name Arabic', key: 'name_ar' },
        { label: 'Name English', key: 'name_en' },
      ],
    };
  },

  async created() {
    this.fetchCountries();
  },

  computed: {
    filteredCountries() {
      if (!this.searchTerm) {
        return this.countries;
      }
      const term = this.searchTerm.toLowerCase();
      return this.countries.filter(
        (country) =>
          country.name.toLowerCase().includes(term) ||
          country.postal_code.toLowerCase().includes(term)
      );
    },
  },

  methods: {
    // fetch countries
    async fetchCountries() {
      try {
        const response = await axios.get(
          `/admin/admin/country/all`
        );
        this.countries = response.data.data;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    deleteCountry(id) {
      console.log("delete country id: ", id);
      axios
        .delete(`/admin/country/delete?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchCountries();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>